import { Tooltip } from '@lokalise/louis';
import { forwardRef } from 'react';
import NavItemContents from './NavItemContents';
import classes from './styles.module.css';

type ProjectNavigationItemProps = {
    label: string;
    badge?: number;
    disabled?: boolean;
    active?: boolean;
    onClick?: () => void;
    href?: string;
    novel?: string;
};

const disabledItemMessage = 'You do not have access to this function';
export const ProjectNavigationItem = forwardRef<HTMLButtonElement, ProjectNavigationItemProps>(
    ({ label, href = '', disabled = false, active = false, badge, onClick, novel }, ref) => (
        <Tooltip tooltip={disabledItemMessage} show={disabled}>
            <div className={disabled ? classes.projectNavigationItemDisabled : classes.projectNavigationItem}>
                {onClick || disabled || !href ? (
                    <button
                        type="button"
                        ref={ref}
                        className={`${classes.withNavLinkStyle} ${disabled ? classes.disabled : ''}`}
                        disabled={disabled}
                        onClick={onClick}
                    >
                        <NavItemContents label={label} badge={badge} novel={novel} />
                    </button>
                ) : (
                    <a href={href} className={`${classes.withNavLinkStyle} `}>
                        <NavItemContents label={label} badge={badge} novel={novel} />
                    </a>
                )}
            </div>
        </Tooltip>
    ),
);

ProjectNavigationItem.displayName = 'ProjectNavigationItem';

export default ProjectNavigationItem;
